module.exports = __webpack_public_path__ + "media/seher_1.1f.843ffba5.mp3";